(() => {
  'use strict';
  const bag = document.getElementById('am-bag-panel');
  if (!bag || typeof bag.showModal !== 'function') return;
  document.documentElement.classList.add('am-commerce-ready');
  let pending = false;
  const closing = new WeakMap();
  const openers = new WeakMap();
  const root = bag.dataset.root;
  const status = document.getElementById('am-cart-status');
  const escapeKey = value => CSS.escape(String(value));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function expanded(dialog, value) {
    document.querySelectorAll(`[data-am-open="${dialog.id}"]`).forEach(el => el.setAttribute('aria-expanded', String(value)));
  }
  function closePanel(dialog, immediate = false) {
    if (!dialog?.open) return;
    clearTimeout(closing.get(dialog));
    dialog.classList.remove('is-open');
    expanded(dialog, false);
    const finish = () => {
      dialog.close();
      if (!document.querySelector('.am-panel[open]')) document.body.classList.remove('am-panel-open');
      const opener = openers.get(dialog);
      if (opener?.isConnected) opener.focus({preventScroll:true});
    };
    if (immediate || reduced.matches) finish();
    else closing.set(dialog, setTimeout(finish, 340));
  }
  function openPanel(dialog, opener) {
    document.querySelectorAll('.am-panel[open]').forEach(other => { if (other !== dialog) closePanel(other, true); });
    clearTimeout(closing.get(dialog));
    if (!dialog.open) {
      openers.set(dialog, opener || document.activeElement);
      dialog.showModal();
    }
    document.body.classList.add('am-panel-open');
    expanded(dialog, true);
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-open')));
  }
  document.querySelectorAll('.am-panel').forEach(dialog => {
    dialog.addEventListener('cancel', event => {event.preventDefault();closePanel(dialog);});
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePanel(dialog);
    });
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-am-open]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const dialog = document.getElementById(opener.dataset.amOpen);
      if (dialog) {event.preventDefault();openPanel(dialog, opener);}
    }
    const closer = event.target.closest('[data-am-close]');
    if (closer) closePanel(closer.closest('dialog'));
    const anchor = event.target.closest('.am-menu-panel a[href]');
    if (anchor) closePanel(anchor.closest('dialog'), true);
  });
  const sections = () => [bag.dataset.sectionId, document.querySelector('[data-am-cart-page]')?.dataset.sectionId].filter(Boolean);
  function busy(value) {
    pending = value;
    document.querySelectorAll('.am-cart-form').forEach(form => form.setAttribute('aria-busy', String(value)));
    document.querySelectorAll('.am-cart-form button,.am-cart-form input,.am-buy-form button,.am-sticky-buy button').forEach(el => {
      if (value) {el.dataset.amWasDisabled = el.disabled ? '1' : '0';el.disabled = true;}
      else if (el.dataset.amWasDisabled !== undefined) {el.disabled = el.dataset.amWasDisabled === '1';delete el.dataset.amWasDisabled;}
    });
  }
  function errors(message = '') {
    document.querySelectorAll('[data-am-cart-error]').forEach(el => {el.textContent = message;el.hidden = !message;});
  }
  function render(data, restore) {
    const html = data.sections?.[bag.dataset.sectionId];
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const contents = parsed.querySelector('[data-am-cart-content="drawer"]');
    if (!contents) return false;
    bag.querySelector('[data-am-cart-content]').replaceWith(contents);
    const page = document.querySelector('[data-am-cart-page]');
    if (page) {
      const pageHtml = data.sections?.[page.dataset.sectionId];
      const pageContents = pageHtml && new DOMParser().parseFromString(pageHtml, 'text/html').querySelector('[data-am-cart-content="page"]');
      if (!pageContents) return false;
      page.querySelector('[data-am-cart-content]').replaceWith(pageContents);
    }
    document.querySelectorAll('[data-am-count]').forEach(el => el.textContent = contents.dataset.count);
    if (restore) {
      const area = restore.context === 'drawer' ? bag : page;
      const line = area?.querySelector(`[data-line-key="${escapeKey(restore.key)}"]`);
      const target = restore.action === 'input' ? line?.querySelector('[data-am-quantity-input]') : line?.querySelector(`[data-am-quantity="${restore.action}"]`);
      (target || area?.querySelector('[data-am-close]') || page?.querySelector('h1'))?.focus({preventScroll:true});
    }
    return true;
  }
  async function refresh() {
    const url = new URL(location.href);
    url.searchParams.set('sections', sections().join(','));
    const response = await fetch(url, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) return false;
    return render({sections:await response.json()});
  }
  async function request(action, body, restore, opener) {
    if (pending) return;
    errors();busy(true);
    let rendered = false;
    try {
      if (body instanceof FormData) {
        body.set('sections', sections().join(','));
        body.set('sections_url', location.pathname + location.search);
      } else {
        body.sections = sections();
        body.sections_url = location.pathname + location.search;
      }
      const response = await fetch(`${root}cart/${action}.js`, {
        method:'POST', headers:body instanceof FormData ? {Accept:'application/json'} : {'Content-Type':'application/json',Accept:'application/json'},
        body:body instanceof FormData ? body : JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        await refresh();
        errors(typeof data.description === 'string' ? data.description : bag.dataset.error);
        openPanel(bag, opener);
        return;
      }
      rendered = render(data, restore);
      if (!rendered) rendered = await refresh();
      if (!rendered) {location.assign(bag.dataset.cartUrl);return;}
      if (action === 'add') openPanel(bag, opener);
      status.textContent = action === 'add' ? bag.dataset.added : bag.dataset.updated;
    } catch {
      // A request may have reached Shopify even when its response is lost. Never repeat an add automatically.
      try {rendered = await refresh();} catch {rendered = false;}
      errors(`${bag.dataset.error} ${bag.dataset.uncertain}`);
      openPanel(bag, opener);
    } finally {busy(false);}
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('.am-buy-form')) {
      event.preventDefault();
      const data = new FormData(form);
      request('add',data,null,event.submitter);
    } else if (form.matches('.am-cart-form') && pending) event.preventDefault();
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-am-quantity],[data-am-remove],[data-am-add]');
    if (!control) return;
    event.preventDefault();
    if (pending) return;
    if (control.dataset.amAdd) {
      request('add',{items:[{id:control.dataset.amAdd,quantity:1}]},null,control);
      return;
    }
    const line = control.closest('[data-line-key]');
    const input = line.querySelector('[data-am-quantity-input]');
    const remove = control.hasAttribute('data-am-remove');
    const quantity = remove ? 0 : Math.max(0, Number(input.value) + Number(control.dataset.amQuantity));
    request('change',{id:line.dataset.lineKey,quantity},{key:line.dataset.lineKey,context:line.closest('[data-am-cart-content]').dataset.amCartContent,action:control.dataset.amQuantity},control);
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-am-quantity-input]');
    if (!input) return;
    if (!input.validity.valid || !Number.isInteger(Number(input.value))) {input.value = input.defaultValue;input.reportValidity();return;}
    const line = input.closest('[data-line-key]');
    request('change',{id:line.dataset.lineKey,quantity:Number(input.value)},{key:line.dataset.lineKey,context:line.closest('[data-am-cart-content]').dataset.amCartContent,action:'input'},input);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh().catch(() => {}); });
})();
